import type { SysMenuDataItem } from "@/services/login";

/**
 * 递归检查权限
 */
export const checkPermission = (
  menus: SysMenuDataItem[],
  authKey: string,
): boolean => {
  for (const menu of menus) {
    if (menu.address === authKey) {
      return true;
    }
    if (menu.children && menu.children.length > 0) {
      if (checkPermission(menu.children, authKey)) {
        return true;
      }
    }
  }
  return false;
};
